export default __webpack_public_path__ + "static/media/image_arrow.f5e7f686.svg";